import styled from 'styled-components';

export const StyledButtons = styled.div`
  display: none;
  flex-direction: row;
  justify-content: space-between;
  z-index: 1000;
  @media all and (max-width: 1200px) {
    display: flex;
  }
  margin-bottom: 15px;
`;
export const StyledRowButtons = styled.div`
  display: none;
  flex-direction: row;
  z-index: 1000;
  display: flex;
  gap: 10px;
`;